<template>
  <div id="app" :style="getStyle('app')">
    <div id="app_container" :class="errorResponse && 'margin-auto'">
      <router-view/>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
// import ActivateVoucher from '@/components/ActivateVoucher.vue'

export default {
  name: 'app',
  components: {
    // ActivateVoucher
  },
  data : function(){       
    return {
      
    }
  },
  mounted() {

  },
  created : function(){
    let params = {
      e:encodeURIComponent(this.$route.query.e).replace(" ","+"),
      campaign:this.$route.params.campaign,
      hostname:window.location.hostname
    };
    this.$store.commit("SET_CAMPAIGN_API_VARS",params);
    this.getCampaign();
  },
  computed: {
      config(){
          return this.$store.getters.getCamapignConfig;
      },

      loaded(){
          return this.$store.getters.getAppLoaded;
      },

      // returns params to let the API know which campaign this is
      apiCampaignParams(){
          return this.$store.getters.getCampaignApiVars;
      },
      errorResponse(){
          return this.$store.getters.getErrorResponse.code >= 0;
      }
  },
  methods:{


    getCampaign()
    {

        let params = this.apiCampaignParams;
        params.q = 'client-info';

        window.axios.get(process.env.VUE_APP_CONTROLLER_URL,{params:params})
        .then(response => {
          document.title = response.data.page_title;
          this.$store.commit("SET_CAMPAIGN_CONFIG",response.data);
          this.$store.commit("SET_APP_LOADED",true);
          if(typeof this.config.toggle_voucher !== 'undefined' && this.config.toggle_voucher){
            this.$store.commit("SET_SCREEN", "toggle-voucher");
          } else if(this.config.uniquecode_redeemed || (typeof this.config.should_redeem !== 'undefined' && !this.config.should_redeem)){
            this.$store.commit("SET_SCREEN", "voucher");
          }
        }).catch(()=>{
          this.$store.commit("SET_SCREEN",'error');
        }).finally(()=>{
          this.loading = false;
        });

    },

  }

}

</script>
